import {
  MockMap,
} from '@ama-sdk/core';
import {
  Journey,
} from '@dapi/sdk';
import {
  AcceptanceRepository,
  BaggageRepository,
  combineCheckInBaggagePolicies,
  combineJourneys,
  combineJourneyTravelers,
  createMockData,
  createMockDataWithResponse,
  createRegulatoryDetail,
  createRegulatoryDetailsReplyData,
  JourneyTravelerRepository,
  MockRegulatoryDetailsReplyData,
  RecursivePartial,
} from '@dapi/sdk/spec';
import {
  acceptedJourney,
  completeExitDateRegulatoryDetails,
  defaultBoardingPassResult,
  missingRegulatoryJourneyElementCommon,
  noItemToPayError,
  seatmap,
} from '../../mock';
import {
  contacts,
  idCard,
  personalDetails,
} from '../../mock/dictionaries';
import {
  assignSeatToJourneyElements,
} from './common/seatmap';

const journeyTemplate: RecursivePartial<Journey> = {
  travelers: combineJourneyTravelers([JourneyTravelerRepository.MAN], {}).items,
  contacts: contacts
};

const journeys = combineJourneys([journeyTemplate]).items;

const completedRegulatoryDetails: MockRegulatoryDetailsReplyData = createRegulatoryDetailsReplyData({
  template: {
    statusCleared: true,
    storedDetails: [
      createRegulatoryDetail({
        template: {
          personalDetails: personalDetails
        }
      }),
      createRegulatoryDetail({
        template: {
          document: idCard
        }
      })
    ],
    missingDetails: []
  }
});

/**
 * OW 1Journey
 * 1ADT
 * No baggage
 * Stored country exit date regulatory details
 */
export const ow1Journey1AdtStoredExitDateRegulatory: MockMap = {
  addRegulatoryDetails: [
    createMockData(completeExitDateRegulatoryDetails),
    createMockData(completedRegulatoryDetails)
  ],
  assignSeatToJourneyElement: assignSeatToJourneyElements(journeys[0], seatmap).map((seat) => createMockDataWithResponse(seat, 201)),
  generateBoardingPasses: [createMockDataWithResponse(defaultBoardingPassResult, 201)],
  getBaggagePoliciesFromJourney: [createMockData(combineCheckInBaggagePolicies().items)],
  getJourneyUnpaidItems: [createMockDataWithResponse(undefined, 404, [noItemToPayError])],
  getRegulatoryDetails: [createMockData(completeExitDateRegulatoryDetails)],
  requestAcceptanceOfJourney: [createMockDataWithResponse(AcceptanceRepository.TWO_SECURITY_QUESTIONS, 201), createMockDataWithResponse(AcceptanceRepository.ACCEPTED, 201)],
  retrieveJourneyBaggages: [createMockData([BaggageRepository.DEFAULT])],
  retrieveJourneys: [
    createMockDataWithResponse([{
      ...journeys[0],
      journeyElements: [missingRegulatoryJourneyElementCommon]
    }], 201),
    createMockDataWithResponse([acceptedJourney], 201)
  ],
  retrieveJourney: [
    createMockData(acceptedJourney)
  ],
  retrieveSeatMapsJourneyDriven: [createMockData(seatmap)]
};
